import React, { Component, ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faRefresh } from '@fortawesome/free-solid-svg-icons';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

class SignatureErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI
    return {
      hasError: true,
      errorMessage: error.message || 'Signature pad error'
    };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Signature Error Boundary caught an error:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, errorMessage: '' });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="border-2 border-red-300 rounded-lg p-6 bg-red-50">
          <div className="text-center space-y-4">
            <FontAwesomeIcon icon={faExclamationTriangle} className="text-4xl text-red-500" />
            <h3 className="text-lg font-medium text-red-800">
              Signature Pad Fehler
            </h3>
            <p className="text-sm text-red-600">
              Die Unterschrift-Komponente ist auf einen Fehler gestoßen. 
              Bitte versuchen Sie es erneut.
            </p>
            <button
              onClick={this.handleReset}
              className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors font-medium"
            >
              <FontAwesomeIcon icon={faRefresh} className="mr-2" />
              Neu laden
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default SignatureErrorBoundary;
